var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.canAnular)?_c('v-btn',{attrs:{"small":"","color":"primary","loading":_vm.loading,"disabled":_vm.loading},on:{"click":function($event){return _vm.anular(_vm.ticket)}}},[_c('v-icon',{attrs:{"small":""}},[_vm._v("mdi-text-box-remove")]),_vm._v("Anular")],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }